const base_path = `/images`
export const CDNDomain = `${process.env.REACT_APP_CDN_URL}`
export type LogoTypeProvider =
  | 'LOGO_KERRY'
  | 'LOGO_FLASH'
  | 'LOGO_JNT'
  | 'LOGO_THAILANDPOST'
  | 'LOGO_BESTEXPRESS'
  | 'LOGO_SPX'

export type LogoTypeSocial =
  | 'LOGO_FACEBOOK'
  | 'LOGO_INSTAGRAM'
  | 'LOGO_TIKTOK'
  | 'LOGO_SHOPEE'
  | 'LOGO_SPX'
  | 'LOGO_LAZADA'
  | 'LOGO_LINE'
  | 'LOGO_ETC'
export const ImageLinks = {
  WEBP_IMG: `${base_path}/webp`,
  LOGO: `${base_path}/png/goodorder-logo-icon.png`,
  LOGO_HORIZONTAL: `${base_path}/png/goodorder-horizontal-logo.png`,
  LOGO_BG_WHITE: `${base_path}/png/logo-bg-white.svg`,
  LOGO_FACEBOOK: `${base_path}/png/facebook-icon.png`,
  LOGO_TIKTOK: `${base_path}/png/tiktok-icon.png`,
  LOGO_INSTAGRAM: `${base_path}/png/instagram-icon.png`,
  LOGO_SHOPEE: `${base_path}/png/shopee-logo-circle.png`,
  LOGO_LAZADA: `${base_path}/png/lazada-icon.png`,
  LOGO_LINE: `${base_path}/svg/line-logo.svg`,
  LOGO_ETC: `${base_path}/png/etc-icon.png`,

  LOGO_THAILANDPOST: `${base_path}/providers/thaipost.png`,
  LOGO_THAIPOST: `${base_path}/providers/thaipost.png`,
  LOGO_KERRY: `${base_path}/providers/kerry.png`,
  LOGO_FLASH: `${base_path}/providers/flash.png`,
  LOGO_JNT: `${base_path}/providers/jnt.png`,
  LOGO_BESTEXPRESS: `${base_path}/providers/bestexpress.png`,
  LOGO_SPXEXPRESS: `${base_path}/providers/spxexpress.png`,
  LOGO_SPX: `${base_path}/providers/spxexpress.png`,

  LOGO_CIRCLE_SHOPEE: `${base_path}/svg/shopee-logo.svg`,
  LOGO_CIRCLE_TIKTOK: `${base_path}/svg/tik-tok-logo-circle.svg`,
  LOGO_CIRCLE_LAZADA: `${base_path}/svg/lazada-logo-circle.svg`,
  LOGO_CIRCLE_LINE_MY_SHOP: `${base_path}/png/line-my-shop-logo-circle.png`,

  LOGO_SHOPEE_HORIZONTAL: `${base_path}/svg/shopee-horizontal-logo.svg`,
  LOGO_LAZADA_HORIZONTAL: `${base_path}/svg/lazada-horizontal-logo.svg`,
  LOGO_TIKTOK_HORIZONTAL: `${base_path}/svg/tiktok-horizontal-logo.svg`,
  LOGO_LINE_MY_SHOP_HORIZONTAL: `${base_path}/svg/line-my-shop-horizontal-logo.svg`,
}
